(() => {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  class FacetFiltersForm extends HTMLElement {
    constructor() {
      super();
      this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);

      const facetForm = this.querySelector("form");
      facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));
    }

    static setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state
          ? event.state.searchParams
          : FacetFiltersForm.searchParamsInitial;
        if (searchParams === FacetFiltersForm.searchParamsPrev) return;
        FacetFiltersForm.renderPage(searchParams, null, false);
      };
      window.addEventListener("popstate", onHistoryChange);
    }

    static toggleActiveFacets(disable = true) {
      document.querySelectorAll(".js-facet-remove").forEach((element) => {
        element.classList.toggle("disabled", disable);
      });
    }

    static renderPage(searchParams, event, updateURLHash = true) {
      FacetFiltersForm.searchParamsPrev = searchParams;
      const sections = FacetFiltersForm.getSections();
      document.querySelector(".loading-modal.modal").style.display = "block";

      sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = (element) => element.url === url;

        FacetFiltersForm.filterData.some(filterDataUrl)
          ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
          : FacetFiltersForm.renderSectionFromFetch(url, event);
      });

      if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }

    static renderSectionFromFetch(url, event) {
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          FacetFiltersForm.filterData = [
            ...FacetFiltersForm.filterData,
            { html, url },
          ];
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
        });
    }

    static renderSectionFromCache(filterDataUrl, event) {
      const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
    }

    static renderProductGridContainer(html) {
      const parsed = new DOMParser().parseFromString(html, "text/html");
      const gridContainer = parsed.getElementById("ProductGridContainer");

      if (gridContainer) {
        document.getElementById("ProductGridContainer").innerHTML =
          gridContainer.innerHTML;
      }

      const currentSearchParams = new URLSearchParams(window.location.search);
      document
        .querySelectorAll(".infinite-scrolling .btn")
        .forEach((button) => {
          currentSearchParams.set("page", 2);
          button.href = `${
            window.location.pathname
          }?${currentSearchParams.toString()}`;
        });

      document.querySelector(".loading-modal.modal").style.display = "none";
    }

    static renderFilters(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, "text/html");

      const facetDetailsElements = parsedHTML.querySelectorAll(
        "#FacetFiltersForm .js-filter"
      );
      const matchesIndex = (element) => {
        const jsFilter = event ? event.target.closest(".js-filter") : undefined;
        return jsFilter
          ? element.dataset.index === jsFilter.dataset.index
          : false;
      };
      const facetsToRender = Array.from(facetDetailsElements).filter(
        (element) => !matchesIndex(element)
      );
      const countsToRender =
        Array.from(facetDetailsElements).find(matchesIndex);

      facetsToRender.forEach((element) => {
        document.querySelector(
          `.js-filter[data-index="${element.dataset.index}"]`
        ).innerHTML = element.innerHTML;
      });

      FacetFiltersForm.renderActiveFacets(parsedHTML);
    }

    static renderActiveFacets(html) {
      const activeFacetElementSelectors = [".active-facets"];

      activeFacetElementSelectors.forEach((selector) => {
        const activeFacetsElement = html.querySelector(selector);
        if (!activeFacetsElement) return;
        document.querySelector(selector).innerHTML =
          activeFacetsElement.innerHTML;
      });

      FacetFiltersForm.toggleActiveFacets(false);
    }

    static renderCounts(source, target) {
      const targetElement = target.querySelector(".facets__selected");
      const sourceElement = source.querySelector(".facets__selected");

      const targetElementAccessibility =
        target.querySelector(".facets__summary");
      const sourceElementAccessibility =
        source.querySelector(".facets__summary");

      if (sourceElement && targetElement) {
        target.querySelector(".facets__selected").outerHTML =
          source.querySelector(".facets__selected").outerHTML;
      }

      if (targetElementAccessibility && sourceElementAccessibility) {
        target.querySelector(".facets__summary").outerHTML =
          source.querySelector(".facets__summary").outerHTML;
      }
    }

    static updateURLHash(searchParams) {
      history.pushState(
        { searchParams: searchParams.toString() },
        "",
        `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
      );
    }

    static getSections() {
      return [
        { section: document.querySelector(".collection-sidebar").dataset.id },
        {
          section: (
            document.querySelector(".product-collection.products-grid") ||
            document.querySelector(".product-list")
          ).dataset.id,
        },
      ];
    }

    createSearchParams(form) {
      const formData = new FormData(form);
      return new URLSearchParams(formData).toString();
    }

    onSubmitForm(searchParams, event) {
      const searchParamsObject = new URLSearchParams(searchParams);
      const currentSearchParamsObject = new URLSearchParams(
        Shopify.queryParams
      );

      if (currentSearchParamsObject.has("view")) {
        searchParamsObject.set("view", currentSearchParamsObject.get("view"));
      }

      if (currentSearchParamsObject.has("sort_by")) {
        searchParamsObject.set(
          "sort_by",
          currentSearchParamsObject.get("sort_by")
        );
      }

      FacetFiltersForm.renderPage(searchParamsObject, event);
    }

    onSubmitHandler(event) {
      event.preventDefault();

      const forms = [];
      const sortFilterForms = document.querySelectorAll(
        "facet-filters-form form"
      );

      sortFilterForms.forEach((form) => {
        if (
          form.id === "FacetSortForm" ||
          form.id === "FacetFiltersForm" ||
          form.id === "FacetSortDrawerForm"
        ) {
          const noJsElements = document.querySelectorAll(".no-js-list");
          noJsElements.forEach((el) => el.remove());
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }

    onActiveFilterClick(event) {
      event.preventDefault();
      FacetFiltersForm.toggleActiveFacets();
      const url =
        event.currentTarget.href.indexOf("?") == -1
          ? ""
          : event.currentTarget.href.slice(
              event.currentTarget.href.indexOf("?") + 1
            );
      FacetFiltersForm.renderPage(url);
    }
  }

  FacetFiltersForm.filterData = [];
  FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
  FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
  customElements.define("facet-filters-form", FacetFiltersForm);
  FacetFiltersForm.setListeners();

  class PriceRange extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll("input").forEach((element) =>
        element.addEventListener("change", this.onRangeChange.bind(this))
      );
      this.setMinAndMaxValues();
    }

    onRangeChange(event) {
      this.adjustToValidValues(event.currentTarget);
      this.setMinAndMaxValues();
    }

    setMinAndMaxValues() {
      const inputs = this.querySelectorAll("input");
      const minInput = inputs[0];
      const maxInput = inputs[1];
      if (maxInput.value) minInput.setAttribute("max", maxInput.value);
      if (minInput.value) maxInput.setAttribute("min", minInput.value);
      if (minInput.value === "") maxInput.setAttribute("min", 0);
      if (maxInput.value === "")
        minInput.setAttribute("max", maxInput.getAttribute("max"));
    }

    adjustToValidValues(input) {
      const value = Number(input.value);
      const min = Number(input.getAttribute("min"));
      const max = Number(input.getAttribute("max"));

      if (value < min) input.value = min;
      if (value > max) input.value = max;
    }
  }

  customElements.define("price-range", PriceRange);

  class FacetRemove extends HTMLElement {
    constructor() {
      super();
      const facetLink = this.querySelector("a");
      facetLink.setAttribute("role", "button");
      facetLink.addEventListener("click", this.closeFilter.bind(this));
      facetLink.addEventListener("keyup", (event) => {
        event.preventDefault();
        if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
      });
    }

    closeFilter(event) {
      event.preventDefault();
      const form =
        this.closest("facet-filters-form") ||
        document.querySelector("facet-filters-form");
      form.onActiveFilterClick(event);
    }
  }

  customElements.define("facet-remove", FacetRemove);

  class ShowMoreButton extends HTMLElement {
    constructor() {
      super();
      const button = this.querySelector("button");
      button.addEventListener("click", (event) => {
        this.expandShowMore(event);
        const nextElementToFocus = event.target
          .closest(".parent-display")
          .querySelector(".show-more-item");
        if (
          nextElementToFocus &&
          !nextElementToFocus.classList.contains("hidden")
        ) {
          nextElementToFocus.querySelector("input").focus();
        }
      });
    }
    expandShowMore(event) {
      const parentDisplay = event.target
        .closest('[id^="Show-More-"]')
        .closest(".parent-display");
      const parentWrap = parentDisplay.querySelector(".parent-wrap");
      this.querySelectorAll(".label-text").forEach((element) =>
        element.classList.toggle("hidden")
      );
      parentDisplay
        .querySelectorAll(".show-more-item")
        .forEach((item) => item.classList.toggle("hidden"));
    }
  }

  customElements.define("show-more-button", ShowMoreButton);
})();
